const truthy = (value) => String(value || "").trim().toLowerCase() === "true";

/**
 * Approved Apple launch candidate (Developer ID + notarized + stapled).
 *
 * Public Pages hosting of the DMG is retired. Distribution will be
 * entitlement-gated (product key `secureai-macos`, SecureShield Pro local-stream pattern)
 * after OWNER Stripe price GO. Until then the kill switch stays OFF and no
 * public binary URL is exposed.
 *
 * Not Mac App Store. Not a multi-platform / Windows GO.
 */
export const SECUREAI_MACOS_RELEASE = Object.freeze({
  version: "0.1.0",
  filename: "SecureAI-0.1.0-arm64.dmg",
  source_commit: "e93c856ca87b371cd928af1854e7eebae7d74994",
  // Historical public path — retired. Must never be used as a live href.
  retired_public_path: "/downloads/secureai/SecureAI-macos.dmg",
  sha256: "acb83421b630369a58bbf9a54211b3517f032a178354dcf19eba9a1921e721b7",
  identity: "Developer ID Application: TripleThree Global Pty Ltd (X67WYY3VGQ)",
  notary_submission_id: "3276a0e7-004e-4d3d-855c-1b4c386198dc",
  distribution: "Direct download — Developer ID signed and notarized by Apple",
  channel: "Not Mac App Store",
  os: "macOS 14 or later",
  chip: "Apple Silicon",
  // Future entitlement catalog key (not wired until price GO).
  product_key: "secureai-macos",
});

function safeSha256(value) {
  const digest = String(value || "").trim().toLowerCase();
  return /^[a-f0-9]{64}$/.test(digest) ? digest : "";
}

/**
 * Kill switch for any future download CTA publication.
 * Default OFF (fail-closed). Do not set true until entitlement gate + Stripe
 * price GO are verified. Even when true later, never point at a public Pages DMG.
 */
export function buildSecureAiStorefront(env = process.env) {
  const downloadLive = truthy(env.REACT_APP_SECUREAI_MACOS_DOWNLOAD_LIVE);
  const overrideSha = safeSha256(env.REACT_APP_SECUREAI_MACOS_SHA256);
  const sha256 = overrideSha || SECUREAI_MACOS_RELEASE.sha256;

  return {
    product_name: "SecureAI",
    identifier: "ai.lightningflow.secureai",
    product_key: SECUREAI_MACOS_RELEASE.product_key,
    platforms: {
      macos: {
        live: downloadLive,
        label: "macOS",
        // Never expose the retired public Pages path as a href.
        url: "",
        sha256,
        version: SECUREAI_MACOS_RELEASE.version,
        filename: SECUREAI_MACOS_RELEASE.filename,
        source_commit: SECUREAI_MACOS_RELEASE.source_commit,
        identity: SECUREAI_MACOS_RELEASE.identity,
        notary_submission_id: SECUREAI_MACOS_RELEASE.notary_submission_id,
        distribution: SECUREAI_MACOS_RELEASE.distribution,
        channel: SECUREAI_MACOS_RELEASE.channel,
        os: SECUREAI_MACOS_RELEASE.os,
        chip: SECUREAI_MACOS_RELEASE.chip,
      },
      windows: {
        live: false,
        label: "Windows",
        status: "Not part of this Apple launch",
      },
    },
  };
}

export const secureAiStorefront = buildSecureAiStorefront();

export function macosDownloadLive(storefront = secureAiStorefront) {
  return Boolean(storefront?.platforms?.macos?.live);
}

export function macosDownloadLabel(storefront = secureAiStorefront) {
  return macosDownloadLive(storefront) ? "Download for Mac" : "macOS download coming soon";
}
